// src/components/layout/SuiteProblemes.tsx — SCE Issues
// Une liste de problèmes annonce sa suite à ses rangées (« Problème suivant »,
// 01/10).
//
// Les rangées (IssueRow, LigneProbleme, rangées du panneau de liste) ouvrent
// la fiche par `useOuvrirFiche`, qui lit ce contexte : il suffit d'envelopper
// une liste pour que sa fiche sache quoi parcourir. Aucune rangée n'a à
// recevoir la liste entière en propriété.
//
// N'envelopper QUE les rangées d'une liste : un fil d'activité ou une
// recherche pris dedans hériteraient d'une suite qui n'est pas la leur.

import { createContext, useContext, useMemo, type ReactNode } from 'react'
import type { Issue } from '@/types/issue.types'
import { suiteDe, type SuiteProblemes } from '@/utils/suiteProblemes'

const ContexteSuite = createContext<SuiteProblemes | null>(null)

/** Suite de la liste qui entoure l'appelant, ou null. */
export function useSuiteListe(): SuiteProblemes | null {
  return useContext(ContexteSuite)
}

export function SuiteListe({
  libelle,
  issues,
  children,
}: {
  libelle: string
  /** Les problèmes affichés, dans l'ordre affiché. */
  issues: readonly Issue[]
  children: ReactNode
}): JSX.Element {
  const suite = useMemo(() => suiteDe(libelle, issues), [libelle, issues])
  return <ContexteSuite.Provider value={suite}>{children}</ContexteSuite.Provider>
}
